export default __webpack_public_path__ + "static/media/resume.d491abfb.jpg";